module.exports = __webpack_public_path__ + "img/want-to-order-icon.bf1ad10.svg";